import React from 'react'

import { menuTab } from '../../../../../../constants/constants'

//View
import ProjectWithdrawPage from '../../../page/requestNewProject/projectWithdraw/projectWithdraw'

//Model
import useResearcher from './useResearcher'
import useFolderAndTabStore from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'

type ResearcherViewProps = ReturnType<typeof useResearcher> & {}
const ResearcherView: React.FC<ResearcherViewProps> = (props) => {
    const {} = props
    const folderAndTabStore = useFolderAndTabStore()

    const renderPage = () => {
        switch (folderAndTabStore?.tabSelected?.id) {
            case menuTab.tab21.id:
            case menuTab.tab25.id:
                return <ProjectWithdrawPage />
            default:
                return <></>
        }
    }
    return renderPage()
}

type ResearcherProps = {
    projectMode: 'CREATE' | 'EDIT'
    callbackSaveComplete?: (resStatus: number, isDraft: boolean) => void
}
const Researcher: React.FC<ResearcherProps> = (props) => {
    const researcherModel = useResearcher()
    return <ResearcherView {...researcherModel} {...props} />
}

export default Researcher
